import './index.scss'
$("header .nav li").eq(1).addClass("active");